export const PAGE_WIDTH = 1100;
